import Vue from 'vue'
import { VCheckbox } from 'vuetify/lib'

export default Vue.extend({
  components: {
    VCheckbox,
  },

  data() {
    return {
      checked: false,
      disabled: false,
      cellActiveHighlight: false,
    }
  },

  computed: {
    getChecked() {
      return this.checked
    },
    isDisabled() {
      return this.disabled
    },
  },

  created() {
    this.checked = this.params.data[this.params.valuefield]
  },

  methods: {
    handleCheckboxToggle(value) {
      this.checked = value
      this.params.callback({
        ...{
          id: this.params.data.id,
          displayName: this.params.data.displayName,
        },
        ...{ [this.params.valuefield]: this.checked },
      })
    },
  },

  template: `<v-checkbox v-model="checked" :disabled="isDisabled" @change="handleCheckboxToggle" class="ma-0 pa-0" :ripple="false" hide-details/>`,
})
